<template>
  <div></div>
</template>

<script>
    import {EventBus} from '@/event-bus.js'
    import AzureService from '@/services/azure.service'
    import UserVoiceService from '@/services/uservoice.service'
    import LocalStorage from '@/services/storage.service'
    import UsersService from '@/services/users.service'
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import DBFunctions from '@/common/DBFunctions.js'
    import * as SpeechSDK from 'microsoft-cognitiveservices-speech-sdk';
    //import store from '@/globalvar.js';
    export default {
        name: 'MdAIDictationSpeech',
        mixins: [ShowMessage, EventBus, DBFunctions],
        props: {

        },
        data() {
            return {
                isUsingPremiumDictation: this.$store.state.isUsingPremiumDictation ?? false,
                isDictationSetup: false,
                recognizing: false,
                speechToken: {
                    token: '',
                    region: ''
                },
                recognizer: null,
                transcript: '',
                interimTranscript: '',
                committedText: '',
                weakPhonemes: [],
                userId: LocalStorage.getUserId(),
                cleanupObj: {
                    transcript: '',
                    weakPhonemes: []
                },
                finalTranscript: '',
                isMounted: false,
                canceled: false,
                userCommands: {},
                userVoiceBreakdownObj: {
                    userId: LocalStorage.getUserId(),
                    weakPhonemes: '',
                    locale: 'en-US',
                    speakingRate: 0,
                    averageAccuracy: 0
                },
                //cleanupQueue: null,
                micWorking: false,
                testingMic: false,
                micLevel: 0,
                micStream: null,
                micError: false,
                micErrorMessage: '',
                micMutedWarning: false,
            }
        },
        methods: {
            async GetSpeechToken() {
                const speechToken = this.$store.state.speechToken;
                const isTokenValid = speechToken.token !== ''
                    && speechToken.region !== ''
                    && speechToken.expiresAt
                    && Date.now() < speechToken.expiresAt;

                if (isTokenValid) {
                    this.speechToken.token = speechToken.token;
                    this.speechToken.region = speechToken.region;
                } else {
                    await this.FetchAndStoreSpeechToken();
                }
            },

            async FetchAndStoreSpeechToken() {
                await AzureService.getSpeechToken()
                    .then(response => {
                        this.speechToken.token = response.data.token;
                        this.speechToken.region = response.data.region;
                        this.$store.commit('setSpeechToken', response.data);
                    })
                    .catch((error) => {
                        this.handleError(error);
                    });
            },

            async CheckUserSubscription() {
                if (this.$store.state.isUsingPremiumDictation !== null) {
                    this.isUsingPremiumDictation = this.$store.state.isUsingPremiumDictation;
                    return;
                }
                try {
                    const response = await UsersService.get(this.userId);
                    this.isUsingPremiumDictation = response.data?.usePremiumDictation ?? false;
                    this.$store.commit('setUsePremiumDictation', this.isUsingPremiumDictation);
                }
                catch (error) {
                    this.handleError(error);
                }
            },

            // Toggle the speech bar visibility
            toggleSpeechBar() {
                var speechBar = document.getElementById('speechBar');
                if (!speechBar) {
                    console.error("Speech bar element not found!");
                    return;
                }
                if(speechBar.classList.contains("active")){
                    speechBar.classList.remove('active');
                } else {
                    speechBar.classList.add('active');
                }
                console.log("toggled speech bar");
            },

            async GetUserCommands() {
                let parameter = {
                    userID: this.userId
                }
                try {
                    const response = await UserVoiceService.listingCommands(parameter);
                    const map = {};
                    (response.data ?? []).filter(cmd => cmd.isActive).forEach(cmd => {
                        map[cmd.phrase_Normalized] = {
                            content: cmd.content,
                            phrase: cmd.phrase,
                            phrase_normalized: cmd.phrase_Normalized
                        };
                    });
                    this.userCommands = map;
                }
                catch (error) {
                    this.handleError(error);
                }
            },

            normalizePhrase(phrase) {
                return phrase.trim().toLowerCase();
            },

            matchCommandTrigger(phrase) {
                const key = this.normalizePhrase(phrase);
                return this.userCommands[key] || null;
            },

            async SpeechToTextFromMic(control) {
                this.finalTranscript = ''
                //await this.CheckUserSubscription();
                if(this.recognizing) {
                    this.stopRecording();
                    return;
                }
                await this.TestMicrophone()

                if(this.micWorking) {
                    if(this.isUsingPremiumDictation) {
                        await this.GetSpeechToken();
                        await this.GetWeakPhonemes();
                        await this.GetUserCommands();
                        const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(this.speechToken.token, this.speechToken.region);
                        speechConfig.speechRecognitionLanguage = 'en-US';
                        speechConfig.setProperty(
                            SpeechSDK.PropertyId.Speech_SegmentationSilenceTimeoutMs,
                            "2000" // wait 3 seconds of silence before finalizing, default is ~500ms
                        );
                        speechConfig.setProperty(
                            SpeechSDK.PropertyId.Speech_SegmentationMaximumTimeMs,
                            "30000" // adjust to however long you need
                        );
    
                        speechConfig.outputFormat = SpeechSDK.OutputFormat.Detailed;
    
                        speechConfig.setProperty(SpeechSDK.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    
                        const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
    
                        this.recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);
                        
                        const phraseList = SpeechSDK.PhraseListGrammar.fromRecognizer(this.recognizer);
                        Object.values(this.userCommands).forEach(cmd => {
                            phraseList.addPhrase(cmd.phrase);
                        });

    
                        this.recognizer.recognizing = (s,e) => {
                            this.interimTranscript = e.result.text;
                            console.log("I am currently here listening")
                            var changed = {
                                    "ControlId":control,
                                    "finalSentence": (this.committedText + " " + this.interimTranscript).trim(),
                                }
                                EventBus.$emit('receivedContinuousS2T', changed);
                        }

                        var segments = []
                        this.recognizer.recognized = async (s,e) => {
                            console.log("I am currently here recognized")
                            if(e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
                                if(typeof e.result === 'undefined') {
                                    this.recognizing = false;
                                    this.recognizer.stopContinuousRecognitionAsync();
                                    return;
                                }
                                console.log("Final result received: " + e.result.text);

                                const commandMatch = this.matchCommandTrigger(e.result.text);
                                const textToInsert = commandMatch ? commandMatch.content : e.result.text;

                                this.committedText += (" " + textToInsert).trim();
                                this.interimTranscript = '';
                                segments.push(textToInsert);
                            }
                        }
        
                        this.recognizer.sessionStopped = async () => {
                            console.log("Session stopped event.");
                            this.recognizer.stopContinuousRecognitionAsync();
                            this.recognizing = false;

                            if(this.canceled) {
                                this.canceled = false;
                                return;
                            }
    
                            const rawTranscript = segments.join(' ');
                            const finalText = this.needsCleanup(this.weakPhonemes)
                                ? await this.CleanupTranscript(rawTranscript, this.weakPhonemes)
                                : rawTranscript;
                            
                            this.finalTranscript = finalText;
                            console.log("Transcript to send: " + this.finalTranscript);
                                var changed = {
                                    "ControlId":control,
                                    "finalSentence": this.finalTranscript,
                                }
                                console.log(changed);
                                EventBus.$emit('receivedAIS2T', changed);
        
                                this.interimTranscript = "";
                                this.committedText = "";
                                this.showMessage(this.$tc('Msg.Success'), 'Dictation finished', 'success')
                        };
        
                        this.recognizer.canceled = (s, e) => {
                            console.log(`CANCELED: Reason=${e.reason}`);
                            if (e.errorCode !== SpeechSDK.CancellationErrorCode.NoError) {
                                this.showMessage(this.$tc('Msg.Error'), e.errorDetails, 'error');
                            }
                            this.toggleSpeechBar();
                            this.canceled = true;
                            this.recognizer.stopContinuousRecognitionAsync();
                            this.recognizing = false;
                        };
        
                        this.recognizer.startContinuousRecognitionAsync();
                    }
                }
                else {
                    this.toggleSpeechBar()
                    return;
                }
            },

            async SpeechToTextSetup() {
                if(this.recognizing) {
                    this.stopRecording();
                    return;
                }
                await this.TestMicrophone()

                if(this.micWorking) {
                    this.startRecording = true
                    if(this.isUsingPremiumDictation) {
                        await this.GetSpeechToken();
    
                        //this.toggleSpeechBar();
                        const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(this.speechToken.token, this.speechToken.region);
                        speechConfig.speechRecognitionLanguage = 'en-US';
                        speechConfig.setProperty(
                            SpeechSDK.PropertyId.Speech_SegmentationSilenceTimeoutMs,
                            "1500" // wait 3 seconds of silence before finalizing, default is ~500ms
                        );
                        speechConfig.outputFormat = SpeechSDK.OutputFormat.Detailed;
    
                        speechConfig.setProperty(SpeechSDK.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    
                        const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
    
                        this.recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);
    
                        const referenceText = "";
    
                        // Pronunciation Assessment Config
                        const pronunciationConfig =
                            new SpeechSDK.PronunciationAssessmentConfig(
                                referenceText,
                                SpeechSDK.PronunciationAssessmentGradingSystem.HundredMark,
                                SpeechSDK.PronunciationAssessmentGranularity.Phoneme,
                                true
                            );
    
                        // Optional prosody scoring
                        pronunciationConfig.enableProsodyAssessment = true;
    
                        // Apply to recognizer
                        pronunciationConfig.applyTo(this.recognizer);
    
                        this.recognizer.recognizing = (s,e) => {
                            this.interimTranscript = e.result.text
                            EventBus.$emit('setupInterimTranscript', e.result.text);
                        }
    
                        this.recognizer.recognized = async (s,e) => {
                            console.log("I am currently here recognized")
                            this.interimTranscript = '';
                            this.$emit('setupInterimTranscript', '');
                            if(e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
                                if(typeof e.result === 'undefined') {
                                    this.recognizing = false;
                                    this.recognizer.stopContinuousRecognitionAsync();
                                    return;
                                }
    
                                const pronunciationResult =
                                    SpeechSDK.PronunciationAssessmentResult
                                        .fromResult(e.result);
                                
                                const jsonResult =
                                    e.result.properties.getProperty(
                                        SpeechSDK.PropertyId
                                            .SpeechServiceResponse_JsonResult
                                    );
                                
                                const detailedResult = JSON.parse(jsonResult);
    
                                const weakPhonemes = [];
    
                                try {
                                    const words =
                                        detailedResult?.NBest?.[0]?.Words || [];
    
                                    words.forEach(word => {
    
                                        const phonemes =
                                            word?.Phonemes || [];
    
                                        phonemes.forEach(phoneme => {
    
                                            const accuracy =
                                                phoneme?.PronunciationAssessment
                                                    ?.AccuracyScore || 0;
    
                                            // Threshold for weak phonemes
                                            if (accuracy < 70) {
    
                                                weakPhonemes.push({
                                                    phoneme: phoneme.Phoneme,
                                                    accuracy
                                                });
    
                                            }
    
                                        });
    
                                    });
                                } catch (err) {
                                    this.showMessage(this.$tc('Msg.Error'), 'Cannot extract user voice breakdown', 'error')
                                    return
                                }
                                
                                this.userVoiceBreakdownObj.weakPhonemes = JSON.stringify(weakPhonemes)
                                this.userVoiceBreakdownObj.speakingRate = pronunciationResult.fluencyScore || 0
                                this.userVoiceBreakdownObj.averageAccuracy = pronunciationResult.accuracyScore || 0
                            }
                        }
        
                        this.recognizer.sessionStopped = async () => {
                            console.log("Session stopped event.");
                            this.recognizer.stopContinuousRecognitionAsync();
                            this.recognizing = false;
                            EventBus.$emit('stopRecording', true);

                            if(this.canceled) {
                                this.canceled = false;
                                return;
                            }
                            await UserVoiceService.addUserVoiceBreakdown(this.userVoiceBreakdownObj).then(response => {
                                    console.log(response.data)
                                    this.showMessage(this.$tc('Msg.Success'), 'User voice breakdown captured. Setup complete.', 'success')
                                }).catch((error) => {
                                    this.handleError(error)
                            })
                        };
        
                        this.recognizer.canceled = (s, e) => {
                            console.log(`CANCELED: Reason=${e.reason}`);
                            if (e.errorCode !== SpeechSDK.CancellationErrorCode.NoError) {
                                this.showMessage(this.$tc('Msg.Error'), e.errorDetails, 'error');
                            }
                            this.toggleSpeechBar();
                            this.canceled = true;
                            this.recognizer.stopContinuousRecognitionAsync();
                            this.recognizing = false;
                        };
        
                        this.recognizer.startContinuousRecognitionAsync();
                    }
                }
                else {
                    this.toggleSpeechBar()
                    return;
                }
            },

            async RecordCommand() {
                if(this.recognizing) {
                    this.stopRecording();
                    return;
                }
                await this.TestMicrophone()

                if(this.micWorking) {
                    this.startRecording = true
                    if(this.isUsingPremiumDictation) {
                        await this.GetSpeechToken();
    
                        //this.toggleSpeechBar();
                        const speechConfig = SpeechSDK.SpeechConfig.fromAuthorizationToken(this.speechToken.token, this.speechToken.region);
                        speechConfig.speechRecognitionLanguage = 'en-US';
                        speechConfig.setProperty(
                            SpeechSDK.PropertyId.Speech_SegmentationSilenceTimeoutMs,
                            "1500" // wait 3 seconds of silence before finalizing, default is ~500ms
                        );
                        speechConfig.outputFormat = SpeechSDK.OutputFormat.Detailed;
    
                        speechConfig.setProperty(SpeechSDK.PropertyId.SpeechServiceResponse_RequestWordLevelTimestamps, "true");
    
                        const audioConfig = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();
    
                        this.recognizer = new SpeechSDK.SpeechRecognizer(speechConfig, audioConfig);
    
                        const referenceText = "";
    
                        // Pronunciation Assessment Config
                        const pronunciationConfig =
                            new SpeechSDK.PronunciationAssessmentConfig(
                                referenceText,
                                SpeechSDK.PronunciationAssessmentGradingSystem.HundredMark,
                                SpeechSDK.PronunciationAssessmentGranularity.Phoneme,
                                true
                            );
    
                        // Optional prosody scoring
                        pronunciationConfig.enableProsodyAssessment = true;
    
                        // Apply to recognizer
                        pronunciationConfig.applyTo(this.recognizer);
    
                        this.recognizer.recognizing = (s,e) => {
                            this.interimTranscript = e.result.text
                            EventBus.$emit('setupInterimTranscript', e.result.text);
                        }

                        var commandSegments = []
    
                        this.recognizer.recognized = async (s,e) => {
                            console.log("I am currently here recognized")
                            this.interimTranscript = '';
                            this.$emit('setupInterimTranscript', '');
                            if(e.result.reason === SpeechSDK.ResultReason.RecognizedSpeech) {
                                if(typeof e.result === 'undefined') {
                                    this.recognizing = false;
                                    this.recognizer.stopContinuousRecognitionAsync();
                                    return;
                                }
                                commandSegments.push(e.result.text)                                
                            }
                        }
        
                        this.recognizer.sessionStopped = () => {
                            console.log("Session stopped event.");
                            this.recognizer.stopContinuousRecognitionAsync();
                            this.recognizing = false;

                            const commandTranscript = commandSegments.join(' ').trim();
                            this.finalTranscript = commandTranscript;
                            //EventBus.$emit('commandFinalTranscript', commandTranscript);
                            EventBus.$emit('finishCommand', commandTranscript);
                            this.interimTranscript = "";
                            EventBus.$emit('stopRecording', true);
                        };
        
                        this.recognizer.canceled = (s, e) => {
                            console.log(`CANCELED: Reason=${e.reason}`);
                            if (e.errorCode !== SpeechSDK.CancellationErrorCode.NoError) {
                                this.showMessage(this.$tc('Msg.Error'), e.errorDetails, 'error');
                            }
                            this.toggleSpeechBar();
                            this.recognizer.stopContinuousRecognitionAsync();
                            this.recognizing = false;
                        };
        
                        this.recognizer.startContinuousRecognitionAsync();
                    }
                }
                else {
                    this.toggleSpeechBar()
                    return;
                }
            },

            async GetWeakPhonemes() {
                try {
                    const response = await UserVoiceService.getByID(this.userId);
                    this.weakPhonemes = response.data?.weakPhonemes ?? [];
                    if(this.weakPhonemes.length == 0) {
                        this.showMessage(this.$tc('Msg.Warning'), 'User has not been set up for AI dictation. Please set up to increase accuracy.', 'warning');
                    }
                }
                catch (error) {
                    this.handleError(error);
                }
            },

            needsCleanup(weakPhonemes) {
                return weakPhonemes && weakPhonemes.length > 0;
            },

            handleError(error) {
                const msg = !error.response
                    ? this.$t('Msg.retrieveInfo')
                    : error.response.status === 500
                    ? this.$t('Msg.ThereWereSomeError')
                    : error.response.data.errorMessage;
                this.showMessage(this.$tc('Msg.Error'), msg, 'error');
            },

            async CleanupTranscript(text, weakPhonemes) {
                this.cleanupObj.transcript = text;
                this.cleanupObj.weakPhonemes = weakPhonemes;

                try {
                    const response = await AzureService.cleanUpTranscript(this.cleanupObj);
                    return response.data;
                } catch (error) {
                    this.handleError(error);
                    return text; // fallback to original text on error
                }
            },

            async TestMicrophone() {
                this.micError = false
                this.micErrorMessage = ''
                try {
                    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                    this.micStream = stream;
                    this.micWorking = true;

                    const audioTrack = stream.getAudioTracks()[0];

                    // Listen for browser-detected mute/unmute
                    audioTrack.onmute = () => {
                        this.micMutedWarning = true;
                    };
                    audioTrack.onunmute = () => {
                        this.micMutedWarning = false;
                    };

                    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
                    const source = audioContext.createMediaStreamSource(stream);
                    const analyser = audioContext.createAnalyser();
                    source.connect(analyser);

                    const dataArray = new Uint8Array(analyser.frequencyBinCount);

                    let silentFrames = 0;
                    const SILENCE_THRESHOLD = 2;       // volume below this counts as "silent"
                    const SILENT_FRAMES_LIMIT = 180;   // ~3 seconds at 60fps

                    const checkLevel = () => {
                        analyser.getByteFrequencyData(dataArray);
                        const volume = dataArray.reduce((a, b) => a + b) / dataArray.length;
                        this.micLevel = volume;

                        if (audioTrack.muted) {
                            this.micMutedWarning = true;
                        } else if (volume < SILENCE_THRESHOLD) {
                            silentFrames++;
                            if (silentFrames > SILENT_FRAMES_LIMIT) {
                                this.micMutedWarning = true;
                            }
                        } else {
                            silentFrames = 0;
                            this.micMutedWarning = false;
                        }

                        if (this.testingMic) requestAnimationFrame(checkLevel);
                    };
                    this.testingMic = true;
                    console.log(this.micMutedWarning)
                    if(this.micMutedWarning == true) {
                        this.showMessage(this.$tc('Msg.Warning'), 'Microphone is muted. Please unmute to continue.', 'warning');
                    }
                    checkLevel();

                } catch (error) {
                    this.micWorking = false;
                    this.micError = true;

                    if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
                        this.micErrorMessage = 'Microphone Permission Denied. Please check the permission of your microphone.';
                    } else if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError') {
                        this.micErrorMessage = 'Microphone not found. Please connect to a microphone before starting dictation';
                    } else {
                        this.micErrorMessage = 'There is an error in connecting to the microphone';
                    }
                    this.showMessage(this.$tc('Msg.Error'), this.micErrorMessage, 'error');
                }
            },

            StopMicTest() {
                this.testingMic = false;
                if (this.micStream) {
                    this.micStream.getTracks().forEach(track => track.stop());
                    this.micStream = null;
                }
            },

            stopRecording() {
                console.log('Recognizer at stop time:', this.recognizer);
                if (this.recognizer) {
                    this.recognizer.stopContinuousRecognitionAsync(
                    () => {
                        this.toggleSpeechBar();
                        this.recognizer.close();
                        this.recognizer = null;
                        this.recognizing = false;
                        this.interimTranscript = "";
                    },
                    (error) => {
                        console.error('Error stopping recognition:', error);
                        this.recognizer.close();
                        this.recognizer = null;
                        this.recognizing = false;
                    }
                    );
                }
                this.testingMic = false;
                if (this.micStream) {
                    this.micStream.getTracks().forEach(track => track.stop());
                    this.micStream = null;
                }
            },
        },

        mounted() {
            if(!this.recognizer) {
                this.CheckUserSubscription();
            }
        },

        created() {
            this.$root.$refs.MdAIDictationSpeech = this;
        },
    }
</script>